module.exports = __webpack_public_path__ + "static/media/beata-carmen-rendiles_small.e2b8c2ad.jpg";